import React, { Component } from 'react';
import { Column, Table, defaultTableRowRenderer } from 'react-virtualized';
import InfiniteList from './InfiniteList';
import _ from 'lodash';

import BooleanAlert from './BooleanAlert';
import Alert from './Alert';
import AppJGraph from './AppJGraph';
import MessageSendDialog from './MessageSendDialog';
import ReactToPrint from './ReactToPrint';

const Api = require('./Config');

const HTNB = '3';
const DMB = '4';
const DMBCN = '7';
const SALES = '5';
const DAILY_DMB = '8';
const SPANISH_DAILY_DMB = '23';
const SPANISH_WEEKLY_DMB = '27';
const DAILY_HTN = '10';
const SPANISH_DAILY_HTN = '21';
const DAILY_HTN_SEN = '13';
const SPANISH_WEEKLY_HTN = '26';
const CVD = '14';
const AVI = '22';
const AST = '17';
const DEP = '25';
const SPANISH_DEP = '28';
const DEP_PHQ8 = '30';
const DEP_BIWEEKLY = '31';

const ALL_GRAPHED = [
  HTNB,
  DMB,
  DMBCN,
  SALES,
  DAILY_DMB,
  SPANISH_DAILY_DMB,
  DAILY_HTN,
  SPANISH_DAILY_HTN,
  DAILY_HTN_SEN,
  CVD,
  AVI,
  AST,
  DEP,
  SPANISH_WEEKLY_HTN,
  SPANISH_WEEKLY_DMB,
  SPANISH_DEP,
  DEP_PHQ8,
  DEP_BIWEEKLY,
];

export default class JourneyDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendMessage: false,
      chartVisible: false,
      surveyVisible: false,
      details: [],
      patient: {},
      device_count: 0,
      tcode: {},
      tcodes: [],
      journey: {},
      surveyQuestionVisible: false,
      response_page_query: '',
      timeRange: 'ALL',
      reloadList: 0,
      print: false,
    };

    this.loadRows = this.loadRows.bind(this);
    this.getTableCell = this.getTableCell.bind(this);
    this.doSendMessage = this.doSendMessage.bind(this);
  }

  async loadRows(startIdx, queryAmount) {
    const tcode = _.get(this.props, 'match.params.id', false) || this.props.t_code;

    let results;
    if (this.props.mode == 'report') {
      results = await Api.getPatientJourneyDetailAdmin(tcode);
    } else {
      results = await Api.getPatientJourneyDetail(tcode, startIdx, queryAmount);
    }

    let journeyDetails = results.details;
    if (startIdx > 0) {
      journeyDetails = this.state.details.concat(journeyDetails);
      results.details = journeyDetails;
    }

    this.setState({ ...results, t_code: tcode });

    return {
      data: results.details,
      maxRows: results.maxRows,
    };
  }

  onSurveyClose() {
    this.setState({ surveyVisible: false });
  }

  getAlertIcon(alert) {
    if (alert == '-') {
      return '-';
    }
    if (alert == '!') {
      return <img src={`${Api.getHost()}docportal_api/critical.svg`} height={20} />;
    }
    if (alert == '*') {
      return <img src={`${Api.getHost()}docportal_api/warning.svg`} height={20} />;
    }
    if (alert == '!!!') {
      return <img src={`${Api.getHost()}docportal_api/emergency.svg`} height={20} />;
    }
    return null;
  }

  showConfirmationOnResend() {
    this.booleanAlert.open(
      'Confirm',
      <div>
        Only use this option in the event the patient made an error and whishes to correct. The incorrect version will
        remain in the journey list as reference but will be removed from any reporting or graphs.
        <br />
        <br />
        Do you wish to proceed?
      </div>,
      () => {
        const survey = this.state.SURVEY;
        const { PMHID } = this.state.SURVEY;
        const { t_code } = this.state;
        this.setState({ surveyVisible: false });
        Api.requestResendAgain(PMHID, t_code)
          .then((data) => {
            if (data.SUCCESS === true) {
              this.alert.open('Success', 'Resent Done!');
              this.setState({ reloadList: this.state.reloadList + 1 });
            } else {
              this.alert.open('Error', 'You cannot resend this message!');
            }
          })
          .catch((err) => {
            this.alert.open('Err', `${err}`);
          });
      },
      () => {},
      'Yes',
      'Cancel'
    );
  }

  getDetail() {
    if (this.state.surveyVisible === false) {
      return null;
    }

    let answerStr = this.state.SURVEY.answer;
    answerStr = answerStr.replace(new RegExp('\t', 'g'), '');
    const answers = JSON.parse(answerStr);

    return (
      <div className="modal show ">
        <div className="modal-dialog modal-lg ">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.onSurveyClose();
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">pt. reply </h4>
              <h5 className="modal-title">
                form
                {this.state.old_reply && <span style={{ color: 'red' }}>Error.</span>}
              </h5>
            </div>
            <div className="modal-body">
              <div style={{ marginTop: 10, maxHeight: 400, overflow: 'auto' }}>
                <table className="table table-stripped">
                  <tbody>
                    {_.map(answers, (a, index) => {
                      const ans = Api.getAnswerFormated(a.answer);
                      let anwerhtml = '<span>' + ans[0] + '</span>';
                      if (ans[1] == true) {
                        anwerhtml = "<img height='40' width='40' src='" + ans[0] + "'/>";
                      }

                      if (a.type == 'DATE') {
                        const dateParts = anwerhtml.split('-');
                        const monthName = Api.getMonthName(dateParts[1]);
                        anwerhtml = `${monthName} ${dateParts[2]}, ${dateParts[0]}`;
                      }

                      return (
                        <tr key={index}>
                          <td dangerouslySetInnerHTML={{ __html: a.question }}></td>
                          <td>
                            <div dangerouslySetInnerHTML={{ __html: anwerhtml }}></div>
                          </td>
                          <td>{this.getAlertIcon(a.alert)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer" style={{ display: 'flex', width: '100%' }}>
              <div style={{ flex: 1, textAlign: 'left' }}>
                {this.state.last_answered == this.state.SURVEY.PMHID && this.state.old_reply !== true && (
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => {
                      this.showConfirmationOnResend();
                    }}
                  >
                    Resend patient survey
                  </button>
                )}
              </div>
              <div>
                {this.state.old_reply !== true && this.state.SURVEY_EXTERNAL !== 'Y' && (
                  <button
                    type="button"
                    onClick={() => {
                      this.requestFaxAgain();
                    }}
                    className="btn btn-info"
                  >
                    Send Fax again
                  </button>
                )}

                <button
                  style={{ marginLeft: 10 }}
                  onClick={() => {
                    this.onSurveyClose();
                  }}
                  type="button"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  requestFaxAgain() {
    const survey = this.state.SURVEY;
    const { PMHID } = this.state.SURVEY;
    const { t_code } = this.state;
    this.setState({ surveyVisible: false });
    Api.requestFaxAgain(PMHID, t_code)
      .then((data) => {
        this.alert.open('Success', `Fax sent with send id:${data.RESULT}`);
      })
      .catch((err) => {
        this.alert.open('Err', `${Err}`);
      });
  }

  showSurvey(data) {
    if (data.SURVEY != null) {
      return (
        <button
          type="button"
          onClick={() => {
            this.setState({
              surveyVisible: true,
              SURVEY: data.SURVEY,
              SURVEY_EXTERNAL: data.is_external,
              old_reply: false,
            });
          }}
          className="btn btn-xs btn-primary"
        >
          pt. reply
        </button>
      );
    }
    if (data.has_survey == 'Y') {
      return (
        <button
          type="button"
          onClick={() => {
            this.showSureyForm(data.response_page_url);
          }}
          className="btn btn-xs btn-warning"
        >
          View Form
        </button>
      );
    }
    return null;
  }

  showSureyForm(response_page_url) {
    let queryString = '';
    if (response_page_url) {
      const queryParts = response_page_url.split('?');
      queryString = queryParts[1];
    }

    this.setState({ surveyQuestionVisible: true, response_page_query: queryString });
  }

  rand(min, max, num) {
    const rtn = [];
    while (rtn.length < num) {
      rtn.push(Math.random() * (max - min) + min);
    }
    return rtn;
  }

  getChart() {
    if (this.state.chartVisible != true) {
      return null;
    }
    const ids = _.get(this, 'props.match.params.id', false) || this.props.t_code;

    return (
      <div className="modal show ">
        <div className="modal-dialog " style={{ top: 40, width: window.innerWidth - 100 }}>
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.setState({ chartVisible: false });
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <div style={{ marginBottom: 30, overflow: 'hidden' }}>
                <div className="container">
                  Journey Logs
                  <br />
                  <select
                    value={this.state.timeRange}
                    onChange={(e) => {
                      this.setState({ timeRange: e.currentTarget.value, chartReset: true });
                      setTimeout(() => {
                        this.setState({ chartReset: false });
                      }, 500);
                    }}
                    style={{ width: 300 }}
                    className="form-control select"
                  >
                    <option value="ALL">All</option>
                    <option value="LAST4">Last 4 weeks</option>
                    <option value="LAST8">Last 8 weeks</option>
                  </select>
                </div>
              </div>
              <div style={{ maxHeight: 500, overflowY: 'scroll' }}>
                {this.state.chartReset != true && <AppJGraph fromPortal timeRange={this.state.timeRange} tcode={ids} />}
                {this.state.chartReset != true && this.state.print && (
                  <AppJGraph
                    fromPortal
                    timeRange={this.state.timeRange}
                    tcode={ids}
                    extraClass="print-graph"
                    maxSlice={10}
                    ref={(ref) => {
                      this.jlogGraph = ref;
                    }}
                  />
                )}
                <ReactToPrint
                  ref={(acomp) => {
                    this.rtp = acomp;
                  }}
                  content={() => {
                    return this.jlogGraph;
                  }}
                  trigger={() => {}}
                  documentTitle={`JLog T-Code ${this.state.tcode.t_code}`}
                  pageStyle="@page { size: landscape; } @media print { body { -webkit-print-color-adjust: exact; } }"
                />
              </div>
            </div>
            <div className="modal-footer">
              {false && (
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={() => {
                    location.replace(
                      `${Api.getHost()}docportal_api/getGraphData.php?T_CODE=${this.props.match.params.id}&FILTER=ALL`
                    );
                  }}
                >
                  Download CSV
                </button>
              )}
              <button
                onClick={() => {
                  this.setState({ print: true });
                  setTimeout(() => {
                    this.rtp.handlePrint();
                  }, 500);
                }}
                className="btn btn-primary"
                type="button"
              >
                Print
              </button>
              <button
                onClick={() => {
                  this.setState({ chartVisible: false, print: false });
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getSurveyQuestionPage() {
    if (this.state.surveyQuestionVisible != true) {
      return null;
    }

    return (
      <div className="modal show ">
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.setState({ surveyQuestionVisible: false });
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              Questions
            </div>
            <div className="modal-body text-center">
              <iframe
                title="surveyCodeFrame"
                style={{ width: '400', height: 500 }}
                frameBorder="none"
                src={`${Api.getHost()}docportal_api/surveypage_show.php?${this.state.response_page_query}`}
              />
            </div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  this.setState({ surveyQuestionVisible: false });
                }}
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  getResendCount(data) {
    if (data.resend_count > 2) {
      return 'Alerted';
    }
    if (data.resend_count > 0) {
      return data.resend_count;
    }
    return '';
  }

  getCurrentStatus(data) {
    return data.acknowledged == 'Y' ? 'Clicked' : data.message_skipped == 'Y' ? 'Skipped' : 'Not clicked';
  }

  async doSendMessage(title, message, link, category_id) {
    if (title.trim == '') {
      this.alert.open('Error', 'Empty title or message found');
      return false;
    }
    this.setState({ sendMessage: false });
    const { t_code } = this.state;

    try {
      const response = await Api.sendMessageToTCode(t_code, title, message, link, category_id);
      if (response.SUCCESS === false) {
        this.alert.open('Error', `${response.ERROR}`);
      } else {
        this.alert.open('Sent', 'Message Sent');
      }
    } catch (err) {
      this.alert.open('Error', `${err}`);
    }

    return true;
  }

  getTableCell({ cellData, dataKey, rowData, rowIndex }) {
    let cellItem;

    switch (dataKey) {
      case 'row_idx':
        if (rowData.TYPE == 'SAVED' && rowData.archived == 'N') {
          const index = rowIndex + 1;
          cellItem = index + '(' + rowData.PMHID + ')';
        } else {
          cellItem = rowIndex + 1;
        }
        break;
      case 'message':
        if (rowData.TYPE == 'SAVED') {
          cellItem = cellData;
        } else {
          cellItem = rowData.message_text;
        }
        break;
      case 'sent_date':
        if (rowData.TYPE == 'SAVED') {
          cellItem = rowData.archived == 'Y' ? rowData.sent_date : Api.getDateFormat(rowData.sent_date);
        } else {
          cellItem = 'scheduled on ' + Api.getDateFormat(rowData.future_date);
        }
        break;
      case 'status':
        if (rowData.TYPE == 'SAVED') {
          cellItem = rowData.archived == 'Y' ? 'Clicked' : this.getCurrentStatus(rowData);
        } else {
          cellItem = 'Pending';
        }
        break;
      case 'resend_count':
        if (rowData.TYPE == 'SAVED') {
          cellItem = this.getResendCount(rowData);
        }
        break;
      case 'pt_reply':
        if (rowData.TYPE == 'SAVED' && rowData.archived == 'Y') {
          cellItem = (
            <button
              type="button"
              onClick={() => {
                this.setState({
                  surveyVisible: true,
                  SURVEY: { answer: rowData.old_reply },
                  old_reply: true,
                });
              }}
              className="btn btn-xs btn-danger"
            >
              Error
            </button>
          );
        } else {
          cellItem = this.showSurvey(rowData);
        }
        break;
      case 'acknowledged_on':
        if (rowData.TYPE == 'SAVED') {
          cellItem = rowData.archived == 'Y' ? rowData.acknowledged_on : Api.getDateFormat(rowData.acknowledged_on);
        }
        break;
    }

    return cellItem;
  }

  getColumnStyle() {
    return { whiteSpace: 'normal' };
  }

  headerRenderer({ label }) {
    return <span style={{ textTransform: 'none', whiteSpace: 'normal' }}>{label}</span>;
  }

  rowRenderer(props) {
    if (props.rowData.TYPE == 'SAVED' && props.rowData.archived == 'Y') {
      props.style = { ...props.style, color: 'red' };
    }

    return defaultTableRowRenderer(props);
  }

  render() {
    return (
      <div>
        <MessageSendDialog
          app_id={this.state.tcode.app_id}
          sendAction={this.doSendMessage}
          onClose={() => {
            this.setState({ sendMessage: false });
          }}
          show={this.state.sendMessage}
          t_code={this.state.t_code}
        />
        <div>
          <div>
            <div className="col-md-4">
              <h4>
                Medical Ref#:
                {this.state.patient.patient_ref}
              </h4>
            </div>
            <div className="col-md-4">
              <h4>
                T-Code:
                {Api.formatTCode(this.state.t_code)}
              </h4>
            </div>
            <div className="col-md-4">
              <h4>
                {ALL_GRAPHED.indexOf(this.state.journey.JID) != -1 && (
                  <button
                    type="button"
                    onClick={() => {
                      this.setState({ timeRange: 'ALL' });
                      this.setState({ chartVisible: true });

                      //
                    }}
                    className="btn btn-primary"
                  >
                    J-Log
                  </button>
                )}
              </h4>
            </div>
          </div>

          <div className="row">
            <div className="col-md-10">
              <div className="row" style={{ marginBottom: 20 }}>
                <div className="col-md-6">
                  <b>Journey</b>: {this.state.journey.journey_name}
                </div>
                <div className="col-md-3">
                  <b>Group</b>: {this.state.tcode.group_name || 'None'}
                </div>
                <div className="col-md-3">
                  <b>Manager Comment</b>: {this.state.tcode.doctor_comment}
                </div>
              </div>
              <InfiniteList lists={this.state.details} loadRows={this.loadRows} reloadList={this.state.reloadList}>
                {({ onRowsRendered, registerChild, width }) => (
                  <Table
                    ref={registerChild}
                    onRowsRendered={onRowsRendered}
                    width={width}
                    height={800}
                    headerHeight={60}
                    rowStyle={{
                      borderBottom: '1px solid #ddd',
                      paddingTop: 8,
                      paddingBottom: 8,
                    }}
                    rowHeight={60}
                    rowCount={this.state.details.length}
                    rowGetter={({ index }) => this.state.details[index]}
                    rowRenderer={this.rowRenderer}
                  >
                    <Column label="#" dataKey="row_idx" cellRenderer={this.getTableCell} width={100} />
                    <Column
                      label="Message"
                      dataKey="message"
                      cellRenderer={this.getTableCell}
                      width={width / 2}
                      style={this.getColumnStyle()}
                      headerRenderer={this.headerRenderer}
                    />
                    <Column
                      label="Sent date"
                      dataKey="sent_date"
                      cellRenderer={this.getTableCell}
                      width={width / 9}
                      style={this.getColumnStyle()}
                      headerRenderer={this.headerRenderer}
                    />
                    <Column
                      label="Status"
                      dataKey="status"
                      cellRenderer={this.getTableCell}
                      width={width / 13}
                      headerRenderer={this.headerRenderer}
                    />
                    <Column
                      label="Resend count"
                      dataKey="resend_count"
                      cellRenderer={this.getTableCell}
                      width={60}
                      headerRenderer={this.headerRenderer}
                    />
                    <Column
                      label="Pt. reply"
                      dataKey="pt_reply"
                      cellRenderer={this.getTableCell}
                      width={width / 12}
                      headerRenderer={this.headerRenderer}
                      headerStyle={{ ...this.getColumnStyle(), textAlign: 'center' }}
                    />
                    <Column
                      label="reply Date"
                      dataKey="acknowledged_on"
                      cellRenderer={this.getTableCell}
                      width={width / 11}
                      style={this.getColumnStyle()}
                      headerRenderer={this.headerRenderer}
                      headerStyle={{ ...this.getColumnStyle(), textAlign: 'center' }}
                    />
                  </Table>
                )}
              </InfiniteList>
            </div>

            <div className="col-md-2">
              <div>
                Connected devices:
                {this.state.device_count}
              </div>
              {this.props.mode != 'report' && (
                <div>
                  {' '}
                  <div style={{ marginTop: 20 }}>Patient's other journeys:</div>
                  {_.map(this.state.tcodes, (data, index) => (
                    <div
                      onClick={() => {
                        this.props.history.push(`/JourneyDetail/${data}`);
                      }}
                      key={index}
                      style={{ color: 'blue', cursor: 'pointer' }}
                    >
                      {Api.formatTCode(data)}
                    </div>
                  ))}
                </div>
              )}

              <div style={{ marginTop: 10 }}>
                <button
                  onClick={() => {
                    this.props.history.push(`/add-new-patients/${this.state.tcode.TID}`);
                    this.setState({ sendMessage: true });
                  }}
                  type="button"
                  className="btn btn-primary"
                >
                  + Add Journey
                </button>
              </div>

              <div style={{ marginTop: 10 }}>
                <button
                  onClick={() => {
                    this.setState({ sendMessage: true });
                  }}
                  type="button"
                  className="btn btn-success"
                >
                  Send Message
                </button>
              </div>

              <div style={{ marginTop: 50 }}>
                {false && (
                  <button
                    type="button"
                    onClick={() => {
                      this.booleanAlert.open('Sure?', 'Are you sure you want to delete?', () => {
                        this.props.history.push('/patients');
                      });
                    }}
                    className="btn btn-danger"
                  >
                    Delete this T-Code
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        {this.getDetail()}
        <Alert ref={(ref) => (this.alert = ref)} />
        <BooleanAlert
          ref={(ref) => {
            this.booleanAlert = ref;
          }}
        />
        {this.getSurveyQuestionPage()}
        {this.getChart()}
      </div>
    );
  }
}
